import { isNightTourRivalName, isStreetTourId, nightTourRivalStyle } from './night-tour-rivals.js';
import type { RaceSettings, RivalStyle } from './types.js';

export const NPC_NAMES = [
  'Mika', 'Nova', 'Jax', 'Sora', 'Rook', 'Inez', 'Tao', 'Lux', 'Vega', 'Remy', 'Kian',
  // A separate support grid keeps championship bosses unique now that all
  // twelve headline names can appear as featured rivals across the tours.
  'Ash', 'Cruz', 'Echo', 'Flint', 'Ghost', 'Hana', 'Jett', 'Kai', 'Lena', 'Onyx', 'Pax', 'Rin',
] as const;
export const NPC_COLOURS = ['#ff4d36', '#4de1ff', '#f4d35e', '#b86cff', '#56e39f', '#f27fae', '#f6f7f8'] as const;
export const RIVAL_STYLES: readonly RivalStyle[] = ['sprinter', 'drift', 'bully', 'grip', 'trickster'];

export interface NpcGridIdentity {
  name: string;
  style: RivalStyle;
  paint: string;
  featured: boolean;
}

/**
 * Name, personality and paint of one rival slot. The race core and the lobby
 * preview share this so the grid a player sees before launch is the grid they
 * actually race.
 */
export function npcGridIdentity(
  index: number,
  settings: Pick<RaceSettings, 'featuredRival' | 'tourId'>,
): NpcGridIdentity {
  const featuredRival = settings.featuredRival?.trim();
  const tourGrid = isStreetTourId(settings.tourId);
  const regularNames = NPC_NAMES.filter((name) => (
    !(tourGrid && isNightTourRivalName(name))
    && (!featuredRival || name.toLocaleLowerCase() !== featuredRival.toLocaleLowerCase())
  ));
  const featured = index === 0 && Boolean(featuredRival);
  const name = featured
    ? featuredRival!
    : regularNames[Math.max(0, index - Number(Boolean(featuredRival))) % regularNames.length] ?? `CPU ${index + 1}`;
  const style = (tourGrid || featured ? nightTourRivalStyle(name) : null)
    ?? RIVAL_STYLES[index % RIVAL_STYLES.length]
    ?? 'grip';
  return { name, style, paint: NPC_COLOURS[index % NPC_COLOURS.length] ?? '#f6f7f8', featured };
}
